export default __webpack_public_path__ + "static/media/armoured-fighting.666d1786.jpg";